import logo from './logo.svg'

export const theme = {
    color: {
      primary: "#E20070",
      primaryHover: "#cb0064",
    },
    logoImage: logo,
    backend: "https://echo.epaper-publishing-one.de/look/",
    directory: "/look/kiosk",
    header: {
      customer: "",
      lineHeader: true,
      title: "Look",
    },
    info: [
      {
      text: 'Impressum',
      link: 'https://www.looklive.at/info/impressum/'
    },
      {
      text: 'Datenschutz',
      link: 'https://www.looklive.at/info/datenschutz-und-cookies/'
    },
  ],

  };